/* eslint-disable react-hooks/exhaustive-deps */
import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom';
import BackIcon from '../../../../assets/BackIcon';
import { getSession } from '../../../redux/actions/authActions';
import { toast } from 'react-toastify';
import {
  deleteCart,
  getCartItems,
  updateCart,
} from '../../../redux/actions/dbactions/cartActions';
import { Header } from '../../Header';
import { BaseUrl } from '../../../redux/config';
import axios from 'axios';
import { getProfileSession } from '../../../redux/actions/dbactions/profileActions';
import FullScreenLoader from '../../../FullScreenLoader';

const CartList = () => {
  let orderPatient = JSON.parse(localStorage.getItem('newPatient'));
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const patient = params.get('patient');
  const hasPatient =
    patient !== 'null' || orderPatient?.svcuser_profile_id ? true : false;
  const { facilityId } = useParams();
  const dispatch = useDispatch();
  const [splInstructions, setSplInstructions] = useState('');
  const [sessionUrl, setSessionUrl] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('stripe');
  const [paymentType, setPaymentType] = useState('full');
  const [partialAmount, setPartialAmount] = useState(0);
  const cartItems = useSelector((state) => state?.cart?.cartItems) || [];
  const [paymentInitialised, setPaymentInitialised] = useState(false);
  const [isSharedPayment, setIsSharedPayment] = useState(false);
  const total =
    cartItems?.length > 0 &&
    cartItems[0]?.svcsc_cart_jsn?.service_order_line?.reduce(
      (sum, item) => sum + Number(item?.svc_price_amt),
      0
    );
  const handlePartialAmountChange = (e) => {
    const value = e.target.value;
    if (!isNaN(value) && value >= 0) {
      if (Number(value) > total) {
        setPartialAmount(total);
      } else {
        setPartialAmount(value);
      }
    }
  };
  const { user_profile_id } = getSession();
  const { profileData } = getProfileSession();

  useEffect(() => {
    dispatch(getCartItems());
  }, []);

  const handleClearCart = async () => {
    try {
      const data = {
        user_profile_id,
        sys_active_yn: 'N',
        sys_user_id: user_profile_id,
      };

      dispatch(deleteCart(data));
    } catch (err) {
      toast.error(
        `${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
    }
  };

  const goToExplore = () => {
    history.push('/dashboard');
  };

  const handleBookie = () => {
    history.push(`/dashboard/explore/${facilityId}/patient-profiles`);
  };

  const deleteCartItem = async (index) => {
    const updatedCartItems =
      cartItems[0]?.svcsc_cart_jsn?.service_order_line?.filter(
        (_, idx) => idx !== index
      );

    const payload = {
      user_profile_id,
      sys_active_yn: 'Y',
      sys_user_id: user_profile_id,
      svcsc_cart_jsn: {
        ...cartItems[0]?.svcsc_cart_jsn,
        service_order_line: updatedCartItems,
      },
    };
    try {
      dispatch(updateCart(payload)).then(() => dispatch(getCartItems()));
    } catch (err) {
      toast.error(
        `${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
    }
  };

  const handleSubmitPay = async () => {
    const { token, user_profile_id } = getSession();
    const postData = {
      ord_svc_date: cartItems[0]?.svcsc_cart_jsn?.ord_svc_date,
      ord_svc_time: cartItems[0]?.svcsc_cart_jsn?.ord_svc_time,
      order_dte_tsp: cartItems[0]?.svcsc_cart_jsn?.order_dte_tsp,
      order_tot_amt: total,
      order_tot_qty: cartItems[0]?.svcsc_cart_jsn?.service_order_line?.length,
      order_tot_tax: 0,
      order_tot_fees: 0,
      order_svcf_id: facilityId,
      user_profile_id:
        orderPatient?.svcuser_reqstr_user_id || cartItems[0]?.user_profile_id,
      order_svc_user_id:
        patient !== 'null' ? patient : orderPatient?.svcuser_profile_id,
      ord_parent_order_id: orderPatient?.order_id
        ? orderPatient?.order_id
        : null,
      order_ship_to_id: 2,
      order_ship_instructions: '',
      order_bill_to_id: 2,
      payment_mode: paymentType,
      order_status_id: 1,
      sys_user_id: user_profile_id,
      role_id: profileData?.role_id,
      sys_source_ip: '192.168.2.2',
      sys_crte_tsp: cartItems[0]?.svcsc_cart_jsn?.sys_crte_tsp,
      sys_last_updte_tsp: cartItems[0]?.svcsc_cart_jsn?.sys_last_updte_tsp,
      sys_ord_active_yn: 'Y',
      service_order_line: cartItems[0]?.svcsc_cart_jsn?.service_order_line,
      payment_method: paymentMethod,
    };
    if (paymentType === 'partial') {
      if (partialAmount <= 0) {
        toast.dismiss();
        toast.error('Amount must be more than 0');
        return;
      }
      postData.order_payment_amt = partialAmount;
    }
    if (isSharedPayment) {
      postData.create_share_payment_link = true;
    }

    try {
      setPaymentInitialised(true);

      let response;
      response = await axios.post(`${BaseUrl}pay/ps`, postData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      localStorage.removeItem('newPatient');

      if (paymentMethod === 'wallet') {
        setSessionUrl('/dashboard?payment_status=success');
      } else {
        setSessionUrl(response?.data?.session_url);
      }
      return response.data;
    } catch (err) {
      if (paymentMethod === 'wallet') {
        setSessionUrl('/dashboard?payment_status=failed');
        return;
      }
      toast.error(
        `${
          err.response?.data?.usr?.message ||
          err.response?.data?.message ||
          err.response?.message ||
          err.message
        }`
      );
      if (err.response?.data?.session_url) {
        setSessionUrl(err.response?.data?.session_url);
      }
    } finally {
      setPaymentInitialised(false);
    }
  };

  const isInsufficientBalance =
    paymentType !== 'partial' && profileData?.wallet_balance < total;

  useEffect(() => {
    if (sessionUrl) {
      window.location.href = sessionUrl;
    }
  }, [sessionUrl]);

  return (
    <div>
      <Header
        pageTitle={`Services List > Cart`}
        icon={<Icon icon="material-symbols:explore-outline" />}
      />
      <FullScreenLoader isLoading={paymentInitialised} />

      <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-wrap m-0">
          Cart (
          {(cartItems &&
            cartItems[0]?.svcsc_cart_jsn?.service_order_line?.length) ||
            0}
          )
          {orderPatient?.svcuser_profile_id
            ? ` for ${orderPatient.user_first_name}`
            : ''}
        </h5>
        <button
          className="sign_btn !text-sm !font-medium !flex gap-1 !items-center !w-fit whitespace-nowrap h-[30px] px-3 sm:h-auto"
          onClick={(e) =>
            Array.isArray(cartItems) && cartItems.length > 0
              ? handleClearCart()
              : goToExplore()
          }
        >
          {Array.isArray(cartItems) && cartItems.length > 0
            ? 'Clear Cart'
            : 'Add Items to Cart'}
        </button>
      </div>

      {cartItems[0]?.svcsc_cart_jsn?.service_order_line?.length > 0 ? (
        <div className="flex md:flex-row flex-col lg:gap-16 gap-8  md:!px-9 !px-4 m-0 mt-5 pb-10">
          <div className="md:w-[70%] w-full">
            <div className="w-fit flex gap-2 items-center">
              <div className="text-white bg-[#1340CD] rounded-[5px] h-5 w-5 text-sm text-center">
                1
              </div>
              <p className="m-0 text-sm text-[#1340CD] font-medium">
                Review selected services
              </p>
            </div>

            <div className="list mt-4 pb-4 ">
              {cartItems[0]?.svcsc_cart_jsn?.service_order_line?.map(
                (item, index) => (
                  <div className="border-b border-b-gray-300 pb-3" key={index}>
                    <div className="flex justify-between w-full items-center mt-2 ">
                      <div className="flex items-center gap-3">
                        <Icon
                          icon="streamline-emojis:hospital"
                          style={{ fontSize: '50px' }}
                        />
                        <div className="mt-3">
                          <h2 className="text-[18px] font-medium m-0">
                            #{item?.svc_id} {item?.svc_name}
                          </h2>
                          {item?.ord_svc_date && (
                            <h2 className="text-base font-medium m-0 text-gray-500">
                              {item?.ord_svc_date}, {item?.ord_svc_time}
                            </h2>
                          )}

                          {item.order_ship_instructions && (
                            <>
                              <span className="text-base font-medium">
                                Special Instructions:
                              </span>{' '}
                              <span className="text-gray-500">
                                {item.order_ship_instructions}
                              </span>
                            </>
                          )}
                        </div>
                      </div>

                      <div className="flex items-center gap-3 mt-[2px]">
                        <h4 className="text-[18px] font-semibold m-0 text-black">
                          ${item?.svc_price_amt}
                        </h4>
                        <p
                          className="text-red-500 text-sm m-0 cursor-pointer"
                          onClick={() => deleteCartItem(index)}
                        >
                          {' '}
                          Delete
                        </p>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>

            <div className="w-fit flex gap-2 items-center sm:mt-4">
              <div className="text-white bg-[#1340CD] rounded-[5px] h-5 w-5 text-sm text-center">
                2
              </div>
              <p className="m-0 text-sm text-[#1340CD] font-medium">
                Add Special Instructions
              </p>
            </div>

            <div className="mt-4">
              <textarea
                placeholder="Example: Please also test for diabetes"
                className="form-control"
                id="customTextInput"
                rows="4"
                value={splInstructions}
                onChange={(e) => setSplInstructions(e.target.value)}
                style={{
                  padding: '5px',
                  fontSize: '14px',
                  width: '100%',
                }}
              />
            </div>
          </div>
          <div className="h-fit md:w-[30%] w-full pb-3">
            <div className="bg-gray-100 py-4 bg-white p-4 rounded-lg shadow-md">
              <h2 className="text-lg font-semibold">
                Selected Services Summary
              </h2>
              <div className="flex justify-between items-center mt-3">
                <p className="text-gray-500">Proposed Total</p>
                <p className="font-semibold">
                  ${total && Number(total)?.toFixed(2)}
                </p>
              </div>
              {paymentType === 'partial' && (
                <div className="flex justify-between items-center">
                  <p className="text-gray-500">Partial Amount To Be Paid</p>
                  <p className="font-semibold">
                    ${total && Number(partialAmount)?.toFixed(2)}
                  </p>
                </div>
              )}
              <div className="flex justify-between items-center mt-4">
                <p className="text-gray-500">Total</p>
                <p className="font-semibold">
                  ${total && Number(total)?.toFixed(2)}
                </p>
              </div>
              {paymentType === 'partial' && (
                <div className="flex justify-between items-center">
                  <p className="text-gray-500">Remaining Amount</p>
                  <p className="font-semibold">
                    ${total && Number(total - partialAmount)?.toFixed(2)}
                  </p>
                </div>
              )}
            </div>

            <div className="mt-4 flex flex-col w-full justify-end gap-2 bg-white p-4 rounded-lg shadow-md">
              {hasPatient && (
                <>
                  <div>
                    <div className="flex justify-between gap-4 items-center">
                      <label className="flex items-center gap-1 cursor-pointer">
                        <input
                          disabled={paymentInitialised}
                          type="checkbox"
                          name="paymentMethod"
                          value="partial"
                          checked={paymentType === 'partial'}
                          onChange={({ target }) => {
                            const { checked } = target;
                            if (!checked) {
                              setPartialAmount(0);
                            }
                            setPaymentType(checked ? 'partial' : 'full');
                          }}
                        />
                        Pay Partially
                      </label>
                    </div>

                    {paymentType === 'partial' && (
                      <div className="mt-2">
                        <input
                          disabled={paymentInitialised}
                          type="number"
                          className="form-control border p-2 w-full rounded-md"
                          placeholder="Enter amount"
                          value={partialAmount}
                          onChange={handlePartialAmountChange}
                        />
                      </div>
                    )}
                    {paymentType === 'partial' ? (
                      <label className="flex items-center gap-1 cursor-pointer my-3">
                        <input
                          disabled={paymentInitialised}
                          type="checkbox"
                          name="paymentMethod"
                          value="partial"
                          checked={isSharedPayment}
                          onChange={({ target }) => {
                            setIsSharedPayment(target.checked);
                          }}
                        />
                        Create Shared Payment Link
                      </label>
                    ) : null}
                  </div>
                  <div className="flex flex-col gap-2 justify-center items-center">
                    <div className="flex flex-col items-center w-full text-center">
                      <label
                        className={`flex items-center gap-1 w-full rounded-md border text-sm justify-center p-[12px] ${
                          paymentMethod === 'stripe'
                            ? 'border-blue-500'
                            : 'border-gray-300'
                        }`}
                      >
                        <input
                          disabled={paymentInitialised}
                          type="radio"
                          name="paymentMethod"
                          value="stripe"
                          checked={paymentMethod === 'stripe'}
                          onChange={() => setPaymentMethod('stripe')}
                        />
                        Credit/Debit Card
                      </label>
                    </div>
                    <div className="flex flex-col items-center w-full text-center">
                      <label
                        className={`flex items-center gap-1 w-full rounded-md border text-sm justify-center p-2  ${
                          isInsufficientBalance
                            ? 'cursor-not-allowed !text-[#769895] bg-gray-200'
                            : 'bg-white border-gray-300'
                        }`}
                      >
                        <input
                          disabled={isInsufficientBalance || paymentInitialised}
                          type="radio"
                          name="paymentMethod"
                          value="wallet"
                          checked={paymentMethod === 'wallet'}
                          onChange={() => setPaymentMethod('wallet')}
                        />
                        <Icon
                          icon="material-symbols-light:account-balance-wallet-outline"
                          className="size-6"
                        />
                        E-Wallet
                        {isInsufficientBalance && (
                          <p className="!text-[#769895] !text-xs m-0">
                            (Insufficient Balance)
                          </p>
                        )}
                      </label>
                      <p className="text-green-600 text-xs font-semibold mt-1">
                        Get 5% discount on paying via Wallet!
                      </p>
                    </div>
                  </div>
                </>
              )}
              <div className="flex gap-2 w-full">
                <button
                  disabled={paymentInitialised}
                  className="bg-[#1340CD] border border-gray-300 py-2 px-2 !rounded-md text-sm text-white w-full"
                  onClick={() =>
                    hasPatient ? handleSubmitPay() : handleBookie()
                  }
                >
                  {hasPatient ? 'Checkout' : 'Add Patient to Cart '}
                </button>
              </div>
              <button
                disabled={paymentInitialised}
                className="bg-white border border-gray-300 py-2 px-3 !rounded-md text-sm flex items-center justify-center gap-1"
                onClick={() => history.push(`/dashboard`)}
              >
                <BackIcon /> Go Back to Services
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex gap-16 sm:!px-9 m-0 mt-5">
          {' '}
          <p className="text-red-500 w-full text-2xl font-semibold text-center">
            Your cart is empty!
          </p>
        </div>
      )}
    </div>
  );
};

export default CartList;
